export default {"src":"/_next/static/media/icon_referral_gift.ba810567.svg","height":190,"width":190,"blurWidth":0,"blurHeight":0};